import React from 'react'

import { Field } from 'formik'

import { Form, Col } from '_zari/core'

const DescuentoMontoFormGroup = ({
  iError,
  iTouched,
  fIsSubmitting,
  handleChange,
  values,
  setValues
}) => {
  return (
    <Form.Group>
      <Form.Label text='MONTO' htmlFor='input-descuentoMonto' md={4} />
      <Col md={8}>
        <Field name='descuentoMonto'>
          {({ field }) => (
            <Form.InputText
              {...field}
              isInvalid={iTouched && iError}
              disabled={fIsSubmitting}
              id='input-descuentoMonto'
              placeholder='0.00'
              onChange={e => {
                handleChange(e)
                values.descuentoMonto = e.target.value
                values.descuentoPorcentaje = ''
                setValues(values)
              }}
            />
          )}
        </Field>
        {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
      </Col>
    </Form.Group>
  )
}

export default React.memo(DescuentoMontoFormGroup)
